const getModuleState = state => state.collapsables

export const isCollapsed = (state, name) => {
  const currentValue = getModuleState(state)[name]
  return currentValue === undefined ? true : currentValue
}